module.exports = __webpack_public_path__ + "media/images/arrow_drop_down-2f45fad50f204188b871dbfd437ae1a6.svg";